import { createStore } from "@stencil/store";
import { FintechContratoDTO } from "../../../utils/dtos/HireFintechResponseDTO";


interface IContractStore{
    contrato?: FintechContratoDTO;
}

export const contractStore = createStore<IContractStore>({
    contrato: undefined
});


export function setContrato(contrato: FintechContratoDTO | undefined){
    contractStore.state.contrato = contrato;
}

export function getContrato(): FintechContratoDTO | undefined {
    return contractStore.state.contrato;
}

export function hasValidContrato(): boolean {
    return contractStore.state.contrato?.categoria === 'SCORE';
}

export function clearContrato() : void {
    contractStore.state.contrato = undefined;
}
